/**
 * Parser constructor.
 */
export abstract class Parser extends Object {
	constructor() {
		super();
	}
}
